import { saveAs } from 'file-saver';
import { FC, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { useAuth } from 'src/contexts';
import { SCHOOLCODE_USERGUIDE_NAME , SCORESENDCODE_USERGUIDE_NAME} from 'src/constants';

const Help: FC = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { isAI, isDI } = useAuth();

    //Conditionally set the PDF file name based on the value of isAI
    const pdfFileName = isAI ? SCHOOLCODE_USERGUIDE_NAME : SCORESENDCODE_USERGUIDE_NAME;

    const handleDownload = async () => {
        try {
            // Define the path to the PDF file in the public folder using the conditional file name
            const  pdfFilePath = `/userguide/${pdfFileName}.pdf`;

            // Open the PDF directly in a new tab with the correct name
            window.open(pdfFilePath, '_blank');

            // Fetch the file to trigger the download
            const response = await fetch(pdfFilePath);
            if (!response.ok) {
                throw new Error(`Error fetching the PDF file: ${response.statusText}`);
            }

            // Convert the response to a Blob
            const fileBlob = await response.blob();

            // Use file-saver to download the file with the correct name
            saveAs(fileBlob, `${pdfFileName}.pdf`);

        } catch (error) {
            console.error('Error downloading the PDF file:', error);
        }
    };

    return (
        <Grid container>
            <Grid item xs={12}>
            {isAI && 
                    <div>
                        <Typography variant="body1">
                            <br />
                            <br />
                            <a href="#!" onClick={handleDownload} style={{ textDecoration: 'underline', color: 'blue' }}>
                                Click here
                            </a>{' '}
                            to download the College Board School Code User Guide for step-by-step instructions on how to submit a request, check the status of a submitted request, and more.
                            <br />
                        </Typography>
                    </div>
             }
            {isDI && 
                    <div>
                        <Typography variant="body1">
                            <br />
                            <br />
                            <a href="#!" onClick={handleDownload} style={{ textDecoration: 'underline', color: 'blue' }}>
                                Click here
                            </a>{' '}
                            to download the College Board Score Send Code User Guide for step-by-step instructions on how to submit a request, check the status of a submitted request, and more.
                            <br />
                        </Typography>
                    </div>
            }   
            </Grid>
        </Grid>
    );
};

export default Help;
